'use strict';

var _ = require('lodash');
var JQXGridColumnFactory = function JQXGridColumnFactory($log, validator, gridColumnConditionallyEditableService, JQXGridCellRendererFactory, JQXGridColumnContext, JQXGridCellTreatmentService, JQXGridColumnEditorsService, gridDropdownPopulateService) {
  var JQXGridColumn = function JQXGridColumn(data, group, customRenderers) {
    this.id = data.id;
    this.datafield = data.field;
    this.dataFieldType = data.dataFieldType;
    this.text = data.title;
    this.pinned = data.frozen;
    this.hidden = !data.visible;
    this.width = data.width === 'auto' ? undefined : data.width || 100;
    this.cellsformat = data.format;
    this.editable = _.isBoolean(data.editable) ? data.editable : _.isObject(data.editable);
    this.editableCondition = _.isObject(data.editable) && data.editable.condition ? data.editable.condition : undefined;
    this.editableDependency = _.isObject(data.editable) && data.editable.dependency ? data.editable.dependency : undefined;
    this.columntype = _.isUndefined(data.columntype) ? 'textbox' : data.columntype;
    this.tooltip = data.tooltip || null;
    this.momentConfig = data.momentConfig;
    this.filterable = data.filterable;
    this.sortable = data.sortable;
    this.menu = data.menu;
    this.fillDownDisabled = data.fillDownDisabled;
    this.sortingIndicator = undefined;
    this.validations = data.validations;
    this.maxAllowedYear = data.maxAllowedYear;
    this.prependEmptyValue = !!data.prependEmptyValue;
    this.allowEmptyValue = !!data.allowEmptyValue;
    this.showOnlyTime = !!data.showOnlyTime;
    this.isUserColumn = !!data.isUserColumn;
    this.delayOneClickSelection = data.delayOneClickSelection;
    this.headerIcon = data.headerIcon;
    this.headerIconTooltip = data.headerIconTooltip;
    this.fieldVariant = data.fieldVariant;
    if (data.cellsformat) {
      this.cellsformat = data.cellsformat;
    }
    var datafield = this.datafield;
    var jqxGridColumnId = this.id;
    var columntype = this.columntype;
    var rendererName = data.renderer;
    var editable = data.editable;
    var editableIf = data.editableIf;
    var self = this;
    if (this.editableCondition || this.editableDependency) {
      this.isConditionalEditable = function (rowIndex, value) {
        if (gridColumnConditionallyEditableService.isColumnConditionallyEditable(editable)) {
          var params = [this.owner.source.loadedData, rowIndex, datafield, value, editable && editable.dependency].concat(editable.params);
          return gridColumnConditionallyEditableService.areEditableConditionsMet(editable.condition, params);
        }
      };
    }
    if (!_.isEmpty(self.validations)) {
      this.validation = function (cell, value, customAllRows) {
        var allRows = customAllRows || this.owner.source.loadedData;
        if (!_.size(allRows) || _.isNil(cell)) {
          return;
        }
        var row = allRows[cell.row];
        var errors = [];
        _.forEach(self.validations, function (validation) {
          if (self.isValidationApplicable(row, validation) && self.conditionMet(row, validation)) {
            if (_.isEmpty(validation.params)) {
              validation.params = [];
            }
            var params = [cell, value, row, allRows].concat(validation.params);
            var ruleValidator = validator[validation.rule];
            if (ruleValidator && !ruleValidator.apply(null, params)) {
              if (!_.isEmpty(validation.processMessage)) {
                var addMessages = '';
                var separator = '';
                for (var i = 0; i < validation.processMessage.addToMessage.length; i++) {
                  addMessages += separator + row[validation.processMessage.addToMessage[i]].join('/');
                  separator = '/';
                }
                var patternToReplace = new RegExp('\\{\\{0\\}\\}', 'g');
                errors.push(validation.processMessage.message.replace(patternToReplace, addMessages));
              } else {
                errors.push(validation.message);
              }
            }
            if (!ruleValidator) {
              $log.error('Undefined validator ' + validation.rule);
            }
          }
        });
        if (!_.isEmpty(errors)) {
          this.columnFieldsValidationErrors = errors;
          return {
            result: false,
            message: errors.join(' ')
          };
        }
        this.columnFieldsValidationErrors = false;
        return true;
      };
    }
    if (columntype === 'datetimeinput' && this.maxAllowedYear) {
      this.createEditor = function (rowIndex, cellValue, editor) {
        editor.jqxDateTimeInput('setMaxDate', new Date(self.maxAllowedYear, 12, 31));
      };
    }
    if (columntype === 'datetimeinput' && this.allowEmptyValue) {
      this.createEditor = function (rowIndex, cellValue, editor) {
        editor.jqxDateTimeInput('showFooter', true);
      };
    }
    if (columntype === 'datetimeinput' && this.showOnlyTime) {
      this.createEditor = function (rowIndex, cellValue, editor) {
        editor.jqxDateTimeInput('showTimeButton', true);
        editor.jqxDateTimeInput('showCalendarButton', false);
      };
    }
    this.initeditor = function (rowIndex, cellvalue, editor) {
      var row = this.owner.source.loadedData[rowIndex];
      var loadedData = this.owner.source.loadedData;
      JQXGridColumnEditorsService.initCustomEditor(editor, row, cellvalue, columntype, jqxGridColumnId, loadedData, datafield, self.prependEmptyValue, self.fieldVariant);
    };
    this.initAvailableDropdownValues = function (rowIndex) {
      var row = this.owner.source.loadedData[rowIndex];
      var loadedData = this.owner.source.loadedData;
      return gridDropdownPopulateService.getDropdownValues(datafield, jqxGridColumnId, row, loadedData);
    };

    //for a column that has different custom editors in cells
    if (data.differentTypesColumn) {
      this.geteditorvalue = function (rowIndex, previousValue, editor, value) {
        var row = this.owner.source.loadedData[rowIndex];
        return JQXGridColumnEditorsService.getValueFromEditor(editor, row, value);
      };
    }
    this.setPercentValue = function (row, datafield, value) {
      if (rendererName === 'percentageRender' && !_.isNil(value)) {
        row[datafield] = Math.round(value * 10000) / 100;
      }
    };
    this.cellbeginedit = function (rowIndex, datafield, columntype, value, row) {
      var calculateRow = this.owner.source.loadedData[rowIndex];
      row = row || calculateRow;
      if (gridColumnConditionallyEditableService.isColumnConditionallyEditable(editable)) {
        var params = [this.owner.source.loadedData, rowIndex, datafield, value, editable && editable.dependency].concat(editable.params);
        var isEditable = gridColumnConditionallyEditableService.areEditableConditionsMet(editable.condition, params);
        if (isEditable) {
          self.setPercentValue(row, datafield, value);
        }
        return isEditable;
      }

      // when a user selects a cell and hits DEL or ENTER, 'row' doesn't have 'isRowEditable' property
      if (row.isRowEditable === false || row.isRowEditable === undefined && calculateRow.isRowEditable === false) {
        return false;
      }
      if (row && editableIf && !_.isEmpty(editableIf)) {
        return row[editableIf] || false;
      }
      self.setPercentValue(row, datafield, value);
      return true;
    };
    this.cellclassname = function (rowId, datafield, value) {
      if (!this.owner.source.loadedData) {
        return;
      }
      var columnSettingsProperties = ['isUserColumn'];
      var disabled = false;
      var rowData = this.owner.source.loadedData[rowId];
      var selectedRowIndexes = this.owner.selectedrowindexes;
      var selectedCells = this.owner.selectedcells;
      if (rowData && editableIf && !_.isEmpty(editableIf)) {
        disabled = !rowData[editableIf];
      }
      if (gridColumnConditionallyEditableService.isColumnConditionallyEditable(editable) && datafield !== '_checkboxcolumn') {
        var params = [this.owner.source.loadedData, rowId, datafield, value, editable && editable.dependency].concat(editable.params);
        disabled = !gridColumnConditionallyEditableService.areEditableConditionsMet(editable.condition, params);
      }
      var dataBeforeRefresh = _.get(this.owner.source, '_source.$dataBeforeRefresh');
      return JQXGridCellTreatmentService.getCellClasses(rowId, rowData, selectedRowIndexes, datafield, value, disabled, dataBeforeRefresh, _.pick(self, columnSettingsProperties), selectedCells);
    };
    if (data.renderer !== undefined) {
      var renderer = customRenderers && customRenderers[data.renderer] || JQXGridCellRendererFactory.getRenderer(data.renderer);
      this.columnContext = new JQXGridColumnContext(data);
      this.cellsrenderer = _.wrap(this.columnContext, renderer);
      this.cellsRendererName = data.renderer;
    }
    this.align = 'center';
    this.cellsalign = data.cellsalign || (this.dataFieldType === 'number' ? 'right' : 'center');
    this.columnHeaderClassName = _.kebabCase(this.text);
    if (group) {
      this.columngroup = group.id;
    }
    this.deleteUndefinedProperties();
  };
  JQXGridColumn.prototype.deleteUndefinedProperties = function () {
    for (var prop in this) {
      if (this.hasOwnProperty(prop) && this[prop] === undefined) {
        delete this[prop];
      }
    }
  };
  JQXGridColumn.prototype.isValidationApplicable = function (row, validation) {
    return !validation.applytoproperties || _.includes(validation.applytoproperties, row.propertyName);
  };
  JQXGridColumn.prototype.conditionMet = function (row, validation) {
    if (_.isUndefined(validation.condition)) {
      return true;
    }
    return row[validation.condition.propertyName] === validation.condition.propertyValue;
  };
  return JQXGridColumn;
};
JQXGridColumnFactory.$inject = ['$log', 'GridColumnValidationService', 'GridColumnConditionallyEditableService', 'JQXGridCellRendererFactory', 'JQXGridColumnContextFactory', 'JQXGridCellTreatmentService', 'JQXGridColumnEditorsService', 'GridDropdownPopulateService'];
module.exports = JQXGridColumnFactory;